// src/data/i18n.js
// ─────────────────────────────────────────────────────────────────────────────
// All UI strings indexed by i18n key, grouped by locale.
// Supported: pt-PT (default) | en-US | es-ES | fr-FR | zh-CN | ja-JP
// Use I18n.t('key', { var: value }) to get a translated string.
// ─────────────────────────────────────────────────────────────────────────────

export const STRINGS = {

  // ── PORTUGUESE (default) ────────────────────────────────────────────────────
  'pt-PT': {

    // ── TitleScene ──────────────────────────────────────────────────────────
    tips_label:   'D I C A',
    options_btn:  '⚙  OPÇÕES',
    tips: [
      'Faz grupos de 3 ou mais para eliminar as peças!',
      'Carrega na Skill quando a barra de energia estiver cheia.',
      'Combos de 4 ou mais geram Fragmentos de Prismara ✦',
      'Junta 100 Fragmentos de Prismara para ganhar uma Lootbox!',
      'Cada Lootbox contém 3 cartas do TCG Pazurumon.',
      'Combos maiores geram fragmentos mais raros — treina bem!',
      'Completa um nível para ganhar uma Lootbox com 3 cartas TCG!',
      'Cartas Legendary são raras — aparece no Slot 3 de cada Lootbox.',
      'Consulta a tua coleção de cartas no botão COLEÇÃO do mapa.',
      'Cada região tem um elemento dominante — usa-o a teu favor!',
      'O Modo Infinito desbloqueia ao completares os 5 mundos.',
    ],

    // ── MapScene ────────────────────────────────────────────────────────────
    region_label:       'Região {n}',
    btn_collection:     'COLEÇÃO',
    btn_scores:         'SCORES',
    btn_store:          '🔓 LOJA',
    btn_reset:          'RESET',
    trainer_level:      'Treinador  Lv.{n}',
    levels_count:       '30 Níveis',
    free:               'Grátis',
    region_unknown:     'Região Desconhecida',
    btn_infinite:       '∞ INFINITO',
    best:               'Melhor: {n}',
    end_of_world:       'FIM\nDO MUNDO',
    region_locked_toast:'Região ainda bloqueada.',
    levels_remaining:   'Faltam {n} nível(is) para desbloquear!',
    btn_close:          'FECHAR',
    region_info:        '{label}  •  30 Níveis  •  Grátis',

    // ── StoreScene ──────────────────────────────────────────────────────────
    store_subtitle:       'AVENTURA COMPLETA',
    store_desc:           'Desbloqueia todos os mundos por um\npreço único — sem subscrições, sem surpresas.',
    feature_volcano:      'Vulcão',
    feature_storm:        'Tempestade Elétrica',
    feature_ocean:        'Oceano Profundo',
    feature_earth:        'Terra Ancestral',
    feature_psychic:      'Abismo Psíquico',
    feature_infinite:     'Modo Infinito',
    feature_badge:        'Badge de Apoiante',
    feature_collection:   'Coleção Portátil',
    feature_r1_sub:       '30 níveis — GRÁTIS para todos',
    feature_new_levels:   '30 novos níveis desbloqueados',
    feature_infinite_sub: 'Desbloqueado imediatamente ao comprar',
    feature_badge_sub:    'Nome com destaque no Leaderboard',
    feature_coll_sub:     'Cartas importáveis no Pazurumon TCG Online',
    badge_free:           'GRÁTIS',
    payment_once:         'pagamento\núnico',
    unlock_btn:           'DESBLOQUEAR AGORA  —  {price}',
    restore_purchase:     'Restaurar compra',
    btn_back:             '← Voltar',
    processing:           'A processar...',
    payment_pending:      'Completa o pagamento no browser →',
    payment_open_tab:     'Abre o separador que acabou de aparecer para pagar.',
    payment_error:        'Erro no pagamento. Tenta novamente.',
    restore_not_found:    'Nenhuma compra encontrada. Contacta o suporte se pagaste.',
    tcg_header:           '🃏  O teu progresso não desaparece',
    tcg_desc:             'As cartas que ganhas neste jogo podem ser importadas\nno Pazurumon TCG Online quando for lançado.',
    collector_id:         'ID do Colecionador:  {id}',
    store_footer:         'Pagamento seguro  •  Sem subscrição  •  Suportas o desenvolvimento independente',
    game_unlocked_title:  'JOGO DESBLOQUEADO!',
    game_unlocked_msg:    'Bem-vindo à aventura completa.\nTodos os mundos e o Modo Infinito\nestão agora disponíveis.',
    tcg_id_cards:         '🃏 ID TCG: {id}  •  {n} cartas guardadas',
    start_adventure:      'COMEÇAR A AVENTURA  →',

    // ── LootboxScene ────────────────────────────────────────────────────────
    lootbox_header:   'LOOTBOX ABERTA',
    tap_each_card:    'Toca em cada carta para revelar',
    duplicate:        'DUPLICADO',
    next_level:       'PRÓXIMO NÍVEL →',
    map_btn:          'MAPA',
    or_back_map:      'ou voltar ao MAPA',
    cloud_sync:       '☁ Coleção guardada na cloud  •  {n} cartas  •  ID: {id}',

    // ── LeaderboardScene ────────────────────────────────────────────────────
    loading:          'Loading...',
    lb_close:         'CLOSE',
    wave:             'wave {n}',
    your_rank:        'Your rank:  #{rank}  •  {score}',
    complete_worlds:  'Complete all 5 worlds to submit',
    play_to_board:    'Play to get on the board',
    submit_btn:       'SUBMIT MY SCORE',
    submitting:       'Submitting...',
    score_submitted:  '✓ Score submitted!',
    server_error:     'Server error — try again.',
    network_error:    'Network error — try again.',
    no_scores:        'No scores yet — be the first!',
    prompt_name:      'Enter your name',
    prompt_public:    'Shown publicly on the leaderboard',
    prompt_cancel:    'Cancel',
    prompt_confirm:   'Confirm',

    // ── CollectionScene ─────────────────────────────────────────────────────
    collection_title: 'COLEÇÃO TCG',
    cards_count:      '{n} / {total} cartas',
    fragments_bar:    '✦ Fragmentos: {n}/{max}  →  +1 Lootbox',
    btn_map_back:     '← MAPA',
    copies_one:       'Tens 1 cópia',
    copies_many:      'Tens {n} cópias',
    tap_close:        'Toca para fechar',

    // ── LevelScene ──────────────────────────────────────────────────────────
    objective:        'OBJETIVO',
    level_label:      'NÍVEL',
    level_status:     'Nível {n} — Objetivo: {type}',
    moves_label:      '{n} jogadas',
    tap_start:        'toca para começar',
    btn_map:          '← MAPA',
    defeat:           'DERROTA',
    taunts: [
      'Fraco... Voltarás mais forte?',
      'A Garra Negra ainda perdoa os fracos.',
      'O vulcão não tem piedade.',
      'Tens potencial. Agora usa-o.',
      'Não esperavas que fosse fácil, pois não?',
    ],
    retry:            'TENTAR DE NOVO',
    map_btn_plain:    'MAPA',
    infinite_title:   '∞ MODO INFINITO',
    infinite_no_goals:'Sem objectivos. Sem limite de jogadas.',
    infinite_time:    'Tens 3 minutos para marcar o máximo.',
    infinite_mult:    'O multiplicador sobe a cada 15 jogadas.',
    no_record:        'Sem recorde ainda — sê o primeiro!',
    play_btn:         'JOGAR',
    time_up:          '∞ TEMPO ESGOTADO',
    final_score:      'Score Final',
    new_record:       '✦ NOVO RECORDE!',
    max_wave:         'Onda máxima: {n}',
    play_again:       'JOGAR DE NOVO',
    victory:          'VITÓRIA',
    next_btn:         'PRÓXIMO →',
    wave_status:      '∞ ONDA {n}  ×{mult} score!',
    tap_reveal:       'Toca para revelar',
    added_bestiary:   '✦  ADICIONADO AO BESTIÁRIO  ✦',
    continue_btn:     'CONTINUAR',
    goals_header:     'Objetivos:',
    goal_collect:     '• Coletar {n} de {color}',
    goal_score:       '• Fazer {n} pontos',
    goal_fragments:   '• Ganhar {n} fragmentos de Prismara',
    no_goals:         'Objetivos: —',
    score_prefix:     'Score:',
    combo_max:        'Combo máx: x{n}',
    time_bonus:       '⏱ Time bonus: +{n}  ({t}s remaining)',
    level_up_msg:     '⬆️ LEVEL UP! Nível {n}',
    skill_target:     '🎯 Escolhe alvo… depois faz uma combo {color} para disparar',
    skill_armed:      '⚡ Skill ARMADA: faz uma combo {color} (maior grupo) para disparar! (ESC cancela)',
    skill_failed:     '💥 Falhou! Era {required} (maior grupo: {actual}). -50% energia',
    shuffle_msg:      '↻ Sem jogadas — a baralhar...',
    error_msg:        '⚠️ Erro — vê Console',
    suspense: {
      fire:     'Algo arde nas profundezas...',
      water:    'Uma presença flui sob a superfície...',
      earth:    'A terra treme com uma nova presença...',
      electric: 'Uma faísca diferente crepita no ar...',
      psychic:  'Uma mente desconhecida toca a tua...',
      default:  'Algo se move nas sombras...',
    },

    // ── NOXYS Cross-Promo ───────────────────────────────────────────────────
    noxys_coming_soon:  'EM BREVE',
    noxys_title:        'PAZZURUMON',
    noxys_subtitle:     'NOXYS — Story Mode',
    noxys_date:         '13.08.2026',
    noxys_tagline:      'SAVE THE DATE. SAVE PRISMARA.',
    noxys_cta:          'Apoia no Kickstarter',
    noxys_dismiss:      'Não mostrar novamente',

    // ── OptionsScene — Tile Style ─────────────────────────────────────────
    opt_tile_style:   'Estilo dos Blocos',
    opt_tile_classic: 'CLÁSSICO',
    opt_tile_prism:   'PRISMA',
    opt_tile_themed:  'PRISMARA',

    // ── ReplayScene (Pazurumon Camera) ───────────────────────────────────
    replay_btn:           '📹 CRIAR CLIP',
    replay_turn:          'JOGADA',
    replay_stickers:      'STICKERS',
    replay_record:        'GRAVAR & PARTILHAR',
    replay_recording:     'A GRAVAR...',
    replay_done:          'REPLAY COMPLETO',
    replay_not_supported: 'Gravação não suportada neste dispositivo',
    replay_error:         'Falha na gravação',
    replay_saved:         'Clip guardado!',
    replay_screenshot:       '📸 FOTO',
    replay_screenshot_saved: 'Screenshot guardado!',

    // ── NameBuilderScene ──────────────────────────────────────────────────
    name_create_title: 'CRIA A TUA IDENTIDADE',
    name_edit_title:   'EDITAR IDENTIDADE',
    name_subtitle:     'Constrói o teu nome Pazurumon',
    name_slot_creature: 'Criatura',
    name_slot_verb:     'Verbo',
    name_slot_noun:     'Nome',
    name_slot_title:    'Título',
    name_slot_role:     'Classe',
    name_slot_place:    'Lugar',
    name_slot_emoji:    'Emoji',
    name_slot_year:     'Ano',
    name_randomize:     '🎲  ALEATÓRIO',
    name_confirm:       '✓  CRIAR IDENTIDADE',
    name_save:          '✓  GUARDAR IDENTIDADE',
    name_skip:          'saltar por agora',
    name_iam:           'EU SOU',
    name_share:         '📤  PARTILHAR',
    name_continue:      'CONTINUAR ▶',
    name_discord_label: 'Discord (opcional)',
    name_discord_tap:   'toca para adicionar @username',
    name_discord_hint:  'Opcional — junta-te à comunidade Pazurumon!',
    name_year_prompt:   'Ano de nascimento (2 dígitos)',
    name_unlock_worlds: 'Completa {n} mundo(s)',
    name_unlock_wave:   'Chega à wave {n} no Infinito',
    name_link_code:     'O TEU CÓDIGO',
    name_link_hint:     'Guarda este código para recuperar a tua identidade em qualquer dispositivo',
    name_recover:       'tenho um código',
    name_recover_title: 'Recuperar Identidade',
    name_recover_hint:  'Introduz o teu código de 6 caracteres',
    name_recover_btn:   'RECUPERAR',
    name_recover_invalid: 'O código tem de ter 6 caracteres',
    name_recover_loading: 'A procurar...',
    name_recover_success: 'Identidade recuperada!',
    name_recover_not_found: 'Código não encontrado',
    name_recover_error: 'Erro de ligação — tenta de novo',
    name_cta:           'Leaderboards, Notícias & Comunidade',

    // ── CreditsScene ────────────────────────────────────────────────────────
    credits_close: '✕  FECHAR',
  },

  // ── ENGLISH ─────────────────────────────────────────────────────────────────
  'en-US': {

    // ── TitleScene ──────────────────────────────────────────────────────────
    tips_label:   'T I P',
    options_btn:  '⚙  OPTIONS',
    tips: [
      'Match 3 or more to clear tiles!',
      'Tap the Skill when the energy bar is full.',
      'Combos of 4 or more generate Prismara Fragments ✦',
      'Collect 100 Prismara Fragments to earn a Lootbox!',
      'Each Lootbox contains 3 Pazurumon TCG cards.',
      'Bigger combos generate rarer fragments — practice hard!',
      'Complete a level to earn a Lootbox with 3 TCG cards!',
      'Legendary cards are rare — they appear in Slot 3 of each Lootbox.',
      'Check your card collection via the COLLECTION button on the map.',
      'Each region has a dominant element — use it to your advantage!',
      'Infinite Mode unlocks when you complete all 5 worlds.',
    ],

    // ── MapScene ────────────────────────────────────────────────────────────
    region_label:       'Region {n}',
    btn_collection:     'COLLECTION',
    btn_scores:         'SCORES',
    btn_store:          '🔓 STORE',
    btn_reset:          'RESET',
    trainer_level:      'Trainer  Lv.{n}',
    levels_count:       '30 Levels',
    free:               'Free',
    region_unknown:     'Unknown Region',
    btn_infinite:       '∞ INFINITE',
    best:               'Best: {n}',
    end_of_world:       'END\nOF WORLD',
    region_locked_toast:'Region still locked.',
    levels_remaining:   '{n} level(s) to unlock!',
    btn_close:          'CLOSE',
    region_info:        '{label}  •  30 Levels  •  Free',

    // ── StoreScene ──────────────────────────────────────────────────────────
    store_subtitle:       'FULL ADVENTURE',
    store_desc:           'Unlock all worlds for a\none-time price — no subscriptions, no surprises.',
    feature_volcano:      'Volcano',
    feature_storm:        'Electric Storm',
    feature_ocean:        'Deep Ocean',
    feature_earth:        'Ancient Earth',
    feature_psychic:      'Psychic Abyss',
    feature_infinite:     'Infinite Mode',
    feature_badge:        'Supporter Badge',
    feature_collection:   'Portable Collection',
    feature_r1_sub:       '30 levels — FREE for everyone',
    feature_new_levels:   '30 new levels unlocked',
    feature_infinite_sub: 'Unlocked immediately on purchase',
    feature_badge_sub:    'Highlighted name on Leaderboard',
    feature_coll_sub:     'Cards importable to Pazurumon TCG Online',
    badge_free:           'FREE',
    payment_once:         'one-time\npayment',
    unlock_btn:           'UNLOCK NOW  —  {price}',
    restore_purchase:     'Restore purchase',
    btn_back:             '← Back',
    processing:           'Processing...',
    payment_pending:      'Complete payment in browser →',
    payment_open_tab:     'Open the tab that just appeared to pay.',
    payment_error:        'Payment error. Try again.',
    restore_not_found:    'No purchase found. Contact support if you paid.',
    tcg_header:           '🃏  Your progress doesn\'t disappear',
    tcg_desc:             'Cards you earn in this game can be imported\ninto Pazurumon TCG Online when it launches.',
    collector_id:         'Collector ID:  {id}',
    store_footer:         'Secure payment  •  No subscription  •  You support independent development',
    game_unlocked_title:  'GAME UNLOCKED!',
    game_unlocked_msg:    'Welcome to the full adventure.\nAll worlds and Infinite Mode\nare now available.',
    tcg_id_cards:         '🃏 TCG ID: {id}  •  {n} cards saved',
    start_adventure:      'START ADVENTURE  →',

    // ── LootboxScene ────────────────────────────────────────────────────────
    lootbox_header:   'LOOTBOX OPENED',
    tap_each_card:    'Tap each card to reveal',
    duplicate:        'DUPLICATE',
    next_level:       'NEXT LEVEL →',
    map_btn:          'MAP',
    or_back_map:      'or go back to MAP',
    cloud_sync:       '☁ Collection saved to cloud  •  {n} cards  •  ID: {id}',

    // ── LeaderboardScene ────────────────────────────────────────────────────
    loading:          'Loading...',
    lb_close:         'CLOSE',
    wave:             'wave {n}',
    your_rank:        'Your rank:  #{rank}  •  {score}',
    complete_worlds:  'Complete all 5 worlds to submit',
    play_to_board:    'Play to get on the board',
    submit_btn:       'SUBMIT MY SCORE',
    submitting:       'Submitting...',
    score_submitted:  '✓ Score submitted!',
    server_error:     'Server error — try again.',
    network_error:    'Network error — try again.',
    no_scores:        'No scores yet — be the first!',
    prompt_name:      'Enter your name',
    prompt_public:    'Shown publicly on the leaderboard',
    prompt_cancel:    'Cancel',
    prompt_confirm:   'Confirm',

    // ── CollectionScene ─────────────────────────────────────────────────────
    collection_title: 'TCG COLLECTION',
    cards_count:      '{n} / {total} cards',
    fragments_bar:    '✦ Fragments: {n}/{max}  →  +1 Lootbox',
    btn_map_back:     '← MAP',
    copies_one:       'You have 1 copy',
    copies_many:      'You have {n} copies',
    tap_close:        'Tap to close',

    // ── LevelScene ──────────────────────────────────────────────────────────
    objective:        'OBJECTIVE',
    level_label:      'LEVEL',
    level_status:     'Level {n} — Objective: {type}',
    moves_label:      '{n} moves',
    tap_start:        'tap to start',
    btn_map:          '← MAP',
    defeat:           'DEFEAT',
    taunts: [
      'Weak... Will you come back stronger?',
      'The Black Claw still forgives the weak.',
      'The volcano shows no mercy.',
      'You have potential. Now use it.',
      'You didn\'t think it would be easy, did you?',
    ],
    retry:            'TRY AGAIN',
    map_btn_plain:    'MAP',
    infinite_title:   '∞ INFINITE MODE',
    infinite_no_goals:'No objectives. No move limit.',
    infinite_time:    'You have 3 minutes to score as high as possible.',
    infinite_mult:    'Multiplier increases every 15 moves.',
    no_record:        'No record yet — be the first!',
    play_btn:         'PLAY',
    time_up:          '∞ TIME\'S UP',
    final_score:      'Final Score',
    new_record:       '✦ NEW RECORD!',
    max_wave:         'Max wave: {n}',
    play_again:       'PLAY AGAIN',
    victory:          'VICTORY',
    next_btn:         'NEXT →',
    wave_status:      '∞ WAVE {n}  ×{mult} score!',
    tap_reveal:       'Tap to reveal',
    added_bestiary:   '✦  ADDED TO BESTIARY  ✦',
    continue_btn:     'CONTINUE',
    goals_header:     'Objectives:',
    goal_collect:     '• Collect {n} of {color}',
    goal_score:       '• Reach {n} points',
    goal_fragments:   '• Earn {n} Prismara fragments',
    no_goals:         'Objectives: —',
    score_prefix:     'Score:',
    combo_max:        'Max combo: x{n}',
    time_bonus:       '⏱ Time bonus: +{n}  ({t}s remaining)',
    level_up_msg:     '⬆️ LEVEL UP! Level {n}',
    skill_target:     '🎯 Choose target… then make a {color} combo to fire',
    skill_armed:      '⚡ Skill ARMED: make a {color} combo (largest group) to fire! (ESC cancels)',
    skill_failed:     '💥 Failed! Was {required} (largest group: {actual}). -50% energy',
    shuffle_msg:      '↻ No moves — shuffling...',
    error_msg:        '⚠️ Error — see Console',
    suspense: {
      fire:     'Something burns in the depths...',
      water:    'A presence flows beneath the surface...',
      earth:    'The earth trembles with a new presence...',
      electric: 'A different spark crackles in the air...',
      psychic:  'An unknown mind touches yours...',
      default:  'Something stirs in the shadows...',
    },

    // ── NOXYS Cross-Promo ───────────────────────────────────────────────────
    noxys_coming_soon:  'COMING SOON',
    noxys_title:        'PAZZURUMON',
    noxys_subtitle:     'NOXYS — Story Mode',
    noxys_date:         '13.08.2026',
    noxys_tagline:      'SAVE THE DATE. SAVE PRISMARA.',
    noxys_cta:          'Back us on Kickstarter',
    noxys_dismiss:      'Don\'t show again',

    // ── OptionsScene — Tile Style ─────────────────────────────────────────
    opt_tile_style:   'Tile Style',
    opt_tile_classic: 'CLASSIC',
    opt_tile_prism:   'PRISM',
    opt_tile_themed:  'PRISMARA',

    // ── ReplayScene (Pazurumon Camera) ───────────────────────────────────
    replay_btn:           '📹 CREATE CLIP',
    replay_turn:          'TURN',
    replay_stickers:      'STICKERS',
    replay_record:        'REC & SHARE',
    replay_recording:     'RECORDING...',
    replay_done:          'REPLAY COMPLETE',
    replay_not_supported: 'Recording not supported on this device',
    replay_error:         'Recording failed',
    replay_saved:         'Clip saved!',
    replay_screenshot:       '📸 PHOTO',
    replay_screenshot_saved: 'Screenshot saved!',

    // ── NameBuilderScene ──────────────────────────────────────────────────
    name_create_title: 'CREATE YOUR IDENTITY',
    name_edit_title:   'EDIT IDENTITY',
    name_subtitle:     'Build your Pazurumon name',
    name_slot_creature: 'Creature',
    name_slot_verb:     'Verb',
    name_slot_noun:     'Noun',
    name_slot_title:    'Title',
    name_slot_role:     'Role',
    name_slot_place:    'Place',
    name_slot_emoji:    'Emoji',
    name_slot_year:     'Year',
    name_randomize:     '🎲  RANDOMIZE',
    name_confirm:       '✓  CREATE IDENTITY',
    name_save:          '✓  SAVE IDENTITY',
    name_skip:          'skip for now',
    name_iam:           'I AM',
    name_share:         '📤  SHARE',
    name_continue:      'CONTINUE ▶',
    name_discord_label: 'Discord (optional)',
    name_discord_tap:   'tap to add @username',
    name_discord_hint:  'Optional — join the Pazurumon community!',
    name_year_prompt:   'Year of birth (2 digits)',
    name_unlock_worlds: 'Complete {n} world(s)',
    name_unlock_wave:   'Reach Infinite wave {n}',
    name_link_code:     'YOUR CODE',
    name_link_hint:     'Save this code to recover your identity on any device',
    name_recover:       'I have a code',
    name_recover_title: 'Recover Identity',
    name_recover_hint:  'Enter your 6-character code',
    name_recover_btn:   'RECOVER',
    name_recover_invalid: 'Code must be 6 characters',
    name_recover_loading: 'Searching...',
    name_recover_success: 'Identity recovered!',
    name_recover_not_found: 'Code not found',
    name_recover_error: 'Connection error — try again',
    name_cta:           'Leaderboards, News & Community',

    // ── CreditsScene ────────────────────────────────────────────────────────
    credits_close: '✕  CLOSE',
  },

  // ── SPANISH ─────────────────────────────────────────────────────────────────
  'es-ES': {

    // ── TitleScene ──────────────────────────────────────────────────────────
    tips_label:   'C O N S E J O',
    options_btn:  '⚙  OPCIONES',
    tips: [
      '¡Haz grupos de 3 o más para eliminar las piezas!',
      'Pulsa la Habilidad cuando la barra de energía esté llena.',
      'Los combos de 4 o más generan Fragmentos de Prismara ✦',
      '¡Junta 100 Fragmentos de Prismara para ganar una Lootbox!',
      'Cada Lootbox contiene 3 cartas del TCG Pazurumon.',
      '¡Los combos grandes generan fragmentos más raros — entrena bien!',
      '¡Completa un nivel para ganar una Lootbox con 3 cartas TCG!',
      'Las cartas Legendary son raras — aparecen en el Slot 3 de cada Lootbox.',
      'Consulta tu colección en el botón COLECCIÓN del mapa.',
      '¡Cada región tiene un elemento dominante — úsalo a tu favor!',
      'El Modo Infinito se desbloquea al completar los 5 mundos.',
    ],

    // ── MapScene ────────────────────────────────────────────────────────────
    region_label:       'Región {n}',
    btn_collection:     'COLECCIÓN',
    btn_scores:         'SCORES',
    btn_store:          '🔓 TIENDA',
    btn_reset:          'RESET',
    trainer_level:      'Entrenador  Lv.{n}',
    levels_count:       '30 Niveles',
    free:               'Gratis',
    region_unknown:     'Región Desconocida',
    btn_infinite:       '∞ INFINITO',
    best:               'Mejor: {n}',
    end_of_world:       'FIN\nDEL MUNDO',
    region_locked_toast:'Región aún bloqueada.',
    levels_remaining:   '¡Faltan {n} nivel(es) para desbloquear!',
    btn_close:          'CERRAR',
    region_info:        '{label}  •  30 Niveles  •  Gratis',

    // ── StoreScene ──────────────────────────────────────────────────────────
    store_subtitle:       'AVENTURA COMPLETA',
    store_desc:           'Desbloquea todos los mundos por un\nprecio único — sin suscripciones, sin sorpresas.',
    feature_volcano:      'Volcán',
    feature_storm:        'Tormenta Eléctrica',
    feature_ocean:        'Océano Profundo',
    feature_earth:        'Tierra Ancestral',
    feature_psychic:      'Abismo Psíquico',
    feature_infinite:     'Modo Infinito',
    feature_badge:        'Insignia de Apoyo',
    feature_collection:   'Colección Portátil',
    feature_r1_sub:       '30 niveles — GRATIS para todos',
    feature_new_levels:   '30 nuevos niveles desbloqueados',
    feature_infinite_sub: 'Desbloqueado inmediatamente al comprar',
    feature_badge_sub:    'Nombre destacado en el Leaderboard',
    feature_coll_sub:     'Cartas importables al Pazurumon TCG Online',
    badge_free:           'GRATIS',
    payment_once:         'pago\núnico',
    unlock_btn:           'DESBLOQUEAR AHORA  —  {price}',
    restore_purchase:     'Restaurar compra',
    btn_back:             '← Volver',
    processing:           'Procesando...',
    payment_pending:      'Completa el pago en el navegador →',
    payment_open_tab:     'Abre la pestaña que acaba de aparecer para pagar.',
    payment_error:        'Error en el pago. Inténtalo de nuevo.',
    restore_not_found:    'No se encontró compra. Contacta soporte si pagaste.',
    tcg_header:           '🃏  Tu progreso no desaparece',
    tcg_desc:             'Las cartas que ganas en este juego se pueden importar\nal Pazurumon TCG Online cuando se lance.',
    collector_id:         'ID del Coleccionista:  {id}',
    store_footer:         'Pago seguro  •  Sin suscripción  •  Apoyas el desarrollo independiente',
    game_unlocked_title:  '¡JUEGO DESBLOQUEADO!',
    game_unlocked_msg:    'Bienvenido a la aventura completa.\nTodos los mundos y el Modo Infinito\nestán ahora disponibles.',
    tcg_id_cards:         '🃏 ID TCG: {id}  •  {n} cartas guardadas',
    start_adventure:      'INICIAR AVENTURA  →',

    // ── LootboxScene ────────────────────────────────────────────────────────
    lootbox_header:   'LOOTBOX ABIERTA',
    tap_each_card:    'Toca cada carta para revelar',
    duplicate:        'DUPLICADO',
    next_level:       'SIGUIENTE NIVEL →',
    map_btn:          'MAPA',
    or_back_map:      'o volver al MAPA',
    cloud_sync:       '☁ Colección guardada en la nube  •  {n} cartas  •  ID: {id}',

    // ── LeaderboardScene ────────────────────────────────────────────────────
    loading:          'Cargando...',
    lb_close:         'CERRAR',
    wave:             'ola {n}',
    your_rank:        'Tu rango:  #{rank}  •  {score}',
    complete_worlds:  'Completa los 5 mundos para enviar',
    play_to_board:    'Juega para aparecer en el tablero',
    submit_btn:       'ENVIAR MI PUNTUACIÓN',
    submitting:       'Enviando...',
    score_submitted:  '✓ ¡Puntuación enviada!',
    server_error:     'Error del servidor — inténtalo de nuevo.',
    network_error:    'Error de red — inténtalo de nuevo.',
    no_scores:        '¡Sin puntuaciones aún — sé el primero!',
    prompt_name:      'Ingresa tu nombre',
    prompt_public:    'Visible públicamente en el leaderboard',
    prompt_cancel:    'Cancelar',
    prompt_confirm:   'Confirmar',

    // ── CollectionScene ─────────────────────────────────────────────────────
    collection_title: 'COLECCIÓN TCG',
    cards_count:      '{n} / {total} cartas',
    fragments_bar:    '✦ Fragmentos: {n}/{max}  →  +1 Lootbox',
    btn_map_back:     '← MAPA',
    copies_one:       'Tienes 1 copia',
    copies_many:      'Tienes {n} copias',
    tap_close:        'Toca para cerrar',

    // ── LevelScene ──────────────────────────────────────────────────────────
    objective:        'OBJETIVO',
    level_label:      'NIVEL',
    level_status:     'Nivel {n} — Objetivo: {type}',
    moves_label:      '{n} jugadas',
    tap_start:        'toca para comenzar',
    btn_map:          '← MAPA',
    defeat:           'DERROTA',
    taunts: [
      '¿Débil... Volverás más fuerte?',
      'La Garra Negra aún perdona a los débiles.',
      'El volcán no tiene piedad.',
      'Tienes potencial. Ahora úsalo.',
      'No esperabas que fuera fácil, ¿verdad?',
    ],
    retry:            'INTENTAR DE NUEVO',
    map_btn_plain:    'MAPA',
    infinite_title:   '∞ MODO INFINITO',
    infinite_no_goals:'Sin objetivos. Sin límite de jugadas.',
    infinite_time:    'Tienes 3 minutos para marcar el máximo.',
    infinite_mult:    'El multiplicador sube cada 15 jugadas.',
    no_record:        '¡Sin récord aún — sé el primero!',
    play_btn:         'JUGAR',
    time_up:          '∞ TIEMPO AGOTADO',
    final_score:      'Puntuación Final',
    new_record:       '✦ ¡NUEVO RÉCORD!',
    max_wave:         'Ola máxima: {n}',
    play_again:       'JUGAR DE NUEVO',
    victory:          'VICTORIA',
    next_btn:         'SIGUIENTE →',
    wave_status:      '∞ OLA {n}  ×{mult} score!',
    tap_reveal:       'Toca para revelar',
    added_bestiary:   '✦  AÑADIDO AL BESTIARIO  ✦',
    continue_btn:     'CONTINUAR',
    goals_header:     'Objetivos:',
    goal_collect:     '• Recolectar {n} de {color}',
    goal_score:       '• Alcanzar {n} puntos',
    goal_fragments:   '• Ganar {n} fragmentos de Prismara',
    no_goals:         'Objetivos: —',
    score_prefix:     'Score:',
    combo_max:        'Combo máx: x{n}',
    time_bonus:       '⏱ Time bonus: +{n}  ({t}s remaining)',
    level_up_msg:     '⬆️ LEVEL UP! Nivel {n}',
    skill_target:     '🎯 Elige objetivo… luego haz un combo {color} para disparar',
    skill_armed:      '⚡ Habilidad LISTA: ¡haz un combo {color} (grupo mayor) para disparar! (ESC cancela)',
    skill_failed:     '💥 ¡Falló! Era {required} (grupo mayor: {actual}). -50% energía',
    shuffle_msg:      '↻ Sin jugadas — barajando...',
    error_msg:        '⚠️ Error — ver Consola',
    suspense: {
      fire:     'Algo arde en las profundidades...',
      water:    'Una presencia fluye bajo la superficie...',
      earth:    'La tierra tiembla con una nueva presencia...',
      electric: 'Una chispa diferente crepita en el aire...',
      psychic:  'Una mente desconocida toca la tuya...',
      default:  'Algo se mueve en las sombras...',
    },

    // ── NOXYS Cross-Promo ───────────────────────────────────────────────────
    noxys_coming_soon:  'MUY PRONTO',
    noxys_title:        'PAZZURUMON',
    noxys_subtitle:     'NOXYS — Story Mode',
    noxys_date:         '13.08.2026',
    noxys_tagline:      'GUARDA LA FECHA. SALVA PRISMARA.',
    noxys_cta:          'Apóyanos en Kickstarter',
    noxys_dismiss:      'No mostrar de nuevo',

    // ── OptionsScene — Tile Style ─────────────────────────────────────────
    opt_tile_style:   'Estilo de Bloques',
    opt_tile_classic: 'CLÁSICO',
    opt_tile_prism:   'PRISMA',
    opt_tile_themed:  'PRISMARA',

    // ── ReplayScene (Pazurumon Camera) ───────────────────────────────────
    replay_btn:           '📹 CREAR CLIP',
    replay_turn:          'JUGADA',
    replay_stickers:      'STICKERS',
    replay_record:        'GRABAR Y COMPARTIR',
    replay_recording:     'GRABANDO...',
    replay_done:          'REPLAY COMPLETO',
    replay_not_supported: 'Grabación no soportada en este dispositivo',
    replay_error:         'Fallo en la grabación',
    replay_saved:         '¡Clip guardado!',
    replay_screenshot:       '📸 FOTO',
    replay_screenshot_saved: '¡Screenshot guardado!',

    // ── NameBuilderScene ──────────────────────────────────────────────────
    name_create_title: 'CREA TU IDENTIDAD',
    name_edit_title:   'EDITAR IDENTIDAD',
    name_subtitle:     'Construye tu nombre Pazurumon',
    name_slot_creature: 'Criatura',
    name_slot_verb:     'Verbo',
    name_slot_noun:     'Nombre',
    name_slot_title:    'Título',
    name_slot_role:     'Clase',
    name_slot_place:    'Lugar',
    name_slot_emoji:    'Emoji',
    name_slot_year:     'Año',
    name_randomize:     '🎲  ALEATORIO',
    name_confirm:       '✓  CREAR IDENTIDAD',
    name_save:          '✓  GUARDAR IDENTIDAD',
    name_skip:          'saltar por ahora',
    name_iam:           'YO SOY',
    name_share:         '📤  COMPARTIR',
    name_continue:      'CONTINUAR ▶',
    name_discord_label: 'Discord (opcional)',
    name_discord_tap:   'toca para añadir @username',
    name_discord_hint:  '¡Opcional — únete a la comunidad Pazurumon!',
    name_year_prompt:   'Año de nacimiento (2 dígitos)',
    name_unlock_worlds: 'Completa {n} mundo(s)',
    name_unlock_wave:   'Alcanza la wave {n} en Infinito',
    name_link_code:     'TU CÓDIGO',
    name_link_hint:     'Guarda este código para recuperar tu identidad en cualquier dispositivo',
    name_recover:       'tengo un código',
    name_recover_title: 'Recuperar Identidad',
    name_recover_hint:  'Introduce tu código de 6 caracteres',
    name_recover_btn:   'RECUPERAR',
    name_recover_invalid: 'El código debe tener 6 caracteres',
    name_recover_loading: 'Buscando...',
    name_recover_success: '¡Identidad recuperada!',
    name_recover_not_found: 'Código no encontrado',
    name_recover_error: 'Error de conexión — inténtalo de nuevo',
    name_cta:           'Clasificaciones, Noticias y Comunidad',

    // ── CreditsScene ────────────────────────────────────────────────────────
    credits_close: '✕  CERRAR',
  },

  // ── FRENCH ──────────────────────────────────────────────────────────────────
  'fr-FR': {

    // ── TitleScene ──────────────────────────────────────────────────────────
    tips_label:   'A S T U C E',
    options_btn:  '⚙  OPTIONS',
    tips: [
      'Aligne 3 tuiles ou plus pour les éliminer !',
      'Appuie sur la Compétence quand la barre d\'énergie est pleine.',
      'Les combos de 4 ou plus génèrent des Fragments de Prismara ✦',
      'Collecte 100 Fragments de Prismara pour gagner une Lootbox !',
      'Chaque Lootbox contient 3 cartes du TCG Pazurumon.',
      'Les grands combos génèrent des fragments plus rares — entraîne-toi !',
      'Complète un niveau pour gagner une Lootbox avec 3 cartes TCG !',
      'Les cartes Légendaires sont rares — elles apparaissent dans le Slot 3.',
      'Consulte ta collection via le bouton COLLECTION sur la carte.',
      'Chaque région a un élément dominant — utilise-le à ton avantage !',
      'Le Mode Infini se débloque en complétant les 5 mondes.',
    ],

    // ── MapScene ────────────────────────────────────────────────────────────
    region_label:       'Région {n}',
    btn_collection:     'COLLECTION',
    btn_scores:         'SCORES',
    btn_store:          '🔓 BOUTIQUE',
    btn_reset:          'RESET',
    trainer_level:      'Dresseur  Niv.{n}',
    levels_count:       '30 Niveaux',
    free:               'Gratuit',
    region_unknown:     'Région Inconnue',
    btn_infinite:       '∞ INFINI',
    best:               'Meilleur : {n}',
    end_of_world:       'FIN\nDU MONDE',
    region_locked_toast:'Région encore verrouillée.',
    levels_remaining:   'Encore {n} niveau(x) pour déverrouiller !',
    btn_close:          'FERMER',
    region_info:        '{label}  •  30 Niveaux  •  Gratuit',

    // ── StoreScene ──────────────────────────────────────────────────────────
    store_subtitle:       'AVENTURE COMPLÈTE',
    store_desc:           'Débloque tous les mondes pour un\nprix unique — sans abonnement, sans surprise.',
    feature_volcano:      'Volcan',
    feature_storm:        'Tempête Électrique',
    feature_ocean:        'Océan Profond',
    feature_earth:        'Terre Ancestrale',
    feature_psychic:      'Abîme Psychique',
    feature_infinite:     'Mode Infini',
    feature_badge:        'Badge Soutien',
    feature_collection:   'Collection Portable',
    feature_r1_sub:       '30 niveaux — GRATUIT pour tous',
    feature_new_levels:   '30 nouveaux niveaux débloqués',
    feature_infinite_sub: 'Débloqué immédiatement à l\'achat',
    feature_badge_sub:    'Nom mis en valeur sur le Classement',
    feature_coll_sub:     'Cartes importables dans Pazurumon TCG Online',
    badge_free:           'GRATUIT',
    payment_once:         'paiement\nunique',
    unlock_btn:           'DÉBLOQUER MAINTENANT  —  {price}',
    restore_purchase:     'Restaurer l\'achat',
    btn_back:             '← Retour',
    processing:           'Traitement en cours...',
    payment_pending:      'Finalise le paiement dans le navigateur →',
    payment_open_tab:     'Ouvre l\'onglet qui vient d\'apparaître pour payer.',
    payment_error:        'Erreur de paiement. Réessaie.',
    restore_not_found:    'Aucun achat trouvé. Contacte le support si tu as payé.',
    tcg_header:           '🃏  Ta progression ne disparaît pas',
    tcg_desc:             'Les cartes gagnées dans ce jeu pourront être importées\ndans Pazurumon TCG Online à son lancement.',
    collector_id:         'ID Collectionneur :  {id}',
    store_footer:         'Paiement sécurisé  •  Sans abonnement  •  Tu soutiens le développement indépendant',
    game_unlocked_title:  'JEU DÉBLOQUÉ !',
    game_unlocked_msg:    'Bienvenue dans l\'aventure complète.\nTous les mondes et le Mode Infini\nsont maintenant disponibles.',
    tcg_id_cards:         '🃏 ID TCG : {id}  •  {n} cartes sauvegardées',
    start_adventure:      'COMMENCER L\'AVENTURE  →',

    // ── LootboxScene ────────────────────────────────────────────────────────
    lootbox_header:   'LOOTBOX OUVERTE',
    tap_each_card:    'Appuie sur chaque carte pour la révéler',
    duplicate:        'DOUBLON',
    next_level:       'NIVEAU SUIVANT →',
    map_btn:          'CARTE',
    or_back_map:      'ou retourner à la CARTE',
    cloud_sync:       '☁ Collection sauvegardée dans le cloud  •  {n} cartes  •  ID : {id}',

    // ── LeaderboardScene ────────────────────────────────────────────────────
    loading:          'Chargement...',
    lb_close:         'FERMER',
    wave:             'vague {n}',
    your_rank:        'Ton rang :  #{rank}  •  {score}',
    complete_worlds:  'Complète les 5 mondes pour soumettre',
    play_to_board:    'Joue pour apparaître dans le classement',
    submit_btn:       'SOUMETTRE MON SCORE',
    submitting:       'Envoi en cours...',
    score_submitted:  '✓ Score soumis !',
    server_error:     'Erreur serveur — réessaie.',
    network_error:    'Erreur réseau — réessaie.',
    no_scores:        'Aucun score encore — sois le premier !',
    prompt_name:      'Entre ton nom',
    prompt_public:    'Affiché publiquement dans le classement',
    prompt_cancel:    'Annuler',
    prompt_confirm:   'Confirmer',

    // ── CollectionScene ─────────────────────────────────────────────────────
    collection_title: 'COLLECTION TCG',
    cards_count:      '{n} / {total} cartes',
    fragments_bar:    '✦ Fragments : {n}/{max}  →  +1 Lootbox',
    btn_map_back:     '← CARTE',
    copies_one:       'Tu as 1 exemplaire',
    copies_many:      'Tu as {n} exemplaires',
    tap_close:        'Appuie pour fermer',

    // ── LevelScene ──────────────────────────────────────────────────────────
    objective:        'OBJECTIF',
    level_label:      'NIVEAU',
    level_status:     'Niveau {n} — Objectif : {type}',
    moves_label:      '{n} coups',
    tap_start:        'appuie pour commencer',
    btn_map:          '← CARTE',
    defeat:           'DÉFAITE',
    taunts: [
      'Faible… Tu reviendras plus fort ?',
      'La Griffe Noire pardonne encore aux faibles.',
      'Le volcan n\'a aucune pitié.',
      'Tu as du potentiel. Maintenant utilise-le.',
      'Tu ne pensais pas que ce serait facile, n\'est-ce pas ?',
    ],
    retry:            'RÉESSAYER',
    map_btn_plain:    'CARTE',
    infinite_title:   '∞ MODE INFINI',
    infinite_no_goals:'Sans objectifs. Sans limite de coups.',
    infinite_time:    'Tu as 3 minutes pour marquer le maximum.',
    infinite_mult:    'Le multiplicateur augmente toutes les 15 coups.',
    no_record:        'Aucun record encore — sois le premier !',
    play_btn:         'JOUER',
    time_up:          '∞ TEMPS ÉCOULÉ',
    final_score:      'Score Final',
    new_record:       '✦ NOUVEAU RECORD !',
    max_wave:         'Vague max : {n}',
    play_again:       'REJOUER',
    victory:          'VICTOIRE',
    next_btn:         'SUIVANT →',
    wave_status:      '∞ VAGUE {n}  ×{mult} score !',
    tap_reveal:       'Appuie pour révéler',
    added_bestiary:   '✦  AJOUTÉ AU BESTIAIRE  ✦',
    continue_btn:     'CONTINUER',
    goals_header:     'Objectifs :',
    goal_collect:     '• Collecter {n} de {color}',
    goal_score:       '• Atteindre {n} points',
    goal_fragments:   '• Gagner {n} fragments de Prismara',
    no_goals:         'Objectifs : —',
    score_prefix:     'Score :',
    combo_max:        'Combo max : x{n}',
    time_bonus:       '⏱ Bonus temps : +{n}  ({t}s restants)',
    level_up_msg:     '⬆️ NIVEAU SUIVANT ! Niveau {n}',
    skill_target:     '🎯 Choisis une cible… puis fais un combo {color} pour tirer',
    skill_armed:      '⚡ Compétence ARMÉE : fais un combo {color} (plus grand groupe) pour tirer ! (ÉCHAP annule)',
    skill_failed:     '💥 Raté ! Il fallait {required} (plus grand groupe : {actual}). -50% énergie',
    shuffle_msg:      '↻ Aucun coup possible — mélange en cours...',
    error_msg:        '⚠️ Erreur — voir la Console',
    suspense: {
      fire:     'Quelque chose brûle dans les profondeurs...',
      water:    'Une présence coule sous la surface...',
      earth:    'La terre tremble sous une nouvelle présence...',
      electric: 'Une étincelle différente crépite dans l\'air...',
      psychic:  'Un esprit inconnu effleure le tien...',
      default:  'Quelque chose se meut dans les ombres...',
    },

    // ── NOXYS Cross-Promo ───────────────────────────────────────────────────
    noxys_coming_soon:  'BIENTÔT',
    noxys_title:        'PAZZURUMON',
    noxys_subtitle:     'NOXYS — Story Mode',
    noxys_date:         '13.08.2026',
    noxys_tagline:      'RETENEZ LA DATE. SAUVEZ PRISMARA.',
    noxys_cta:          'Soutenez-nous sur Kickstarter',
    noxys_dismiss:      'Ne plus afficher',

    // ── OptionsScene — Tile Style ─────────────────────────────────────────
    opt_tile_style:   'Style des Blocs',
    opt_tile_classic: 'CLASSIQUE',
    opt_tile_prism:   'PRISME',
    opt_tile_themed:  'PRISMARA',

    // ── ReplayScene (Pazurumon Camera) ───────────────────────────────────
    replay_btn:           '📹 CRÉER CLIP',
    replay_turn:          'TOUR',
    replay_stickers:      'STICKERS',
    replay_record:        'ENREGISTRER & PARTAGER',
    replay_recording:     'ENREGISTREMENT...',
    replay_done:          'REPLAY TERMINÉ',
    replay_not_supported: 'Enregistrement non pris en charge sur cet appareil',
    replay_error:         'Échec de l\'enregistrement',
    replay_saved:         'Clip sauvegardé !',
    replay_screenshot:       '📸 PHOTO',
    replay_screenshot_saved: 'Capture sauvegardée !',

    // ── NameBuilderScene ──────────────────────────────────────────────────
    name_create_title: 'CRÉE TON IDENTITÉ',
    name_edit_title:   'MODIFIER L\'IDENTITÉ',
    name_subtitle:     'Construis ton nom Pazurumon',
    name_slot_creature: 'Créature',
    name_slot_verb:     'Verbe',
    name_slot_noun:     'Nom',
    name_slot_title:    'Titre',
    name_slot_role:     'Classe',
    name_slot_place:    'Lieu',
    name_slot_emoji:    'Emoji',
    name_slot_year:     'Année',
    name_randomize:     '🎲  ALÉATOIRE',
    name_confirm:       '✓  CRÉER L\'IDENTITÉ',
    name_save:          '✓  SAUVEGARDER',
    name_skip:          'passer pour l\'instant',
    name_iam:           'JE SUIS',
    name_share:         '📤  PARTAGER',
    name_continue:      'CONTINUER ▶',
    name_discord_label: 'Discord (facultatif)',
    name_discord_tap:   'appuie pour ajouter @username',
    name_discord_hint:  'Facultatif — rejoins la communauté Pazurumon !',
    name_year_prompt:   'Année de naissance (2 chiffres)',
    name_unlock_worlds: 'Termine {n} monde(s)',
    name_unlock_wave:   'Atteins la wave {n} en Infini',
    name_link_code:     'TON CODE',
    name_link_hint:     'Conserve ce code pour récupérer ton identité sur n\'importe quel appareil',
    name_recover:       'j\'ai un code',
    name_recover_title: 'Récupérer l\'identité',
    name_recover_hint:  'Entre ton code à 6 caractères',
    name_recover_btn:   'RÉCUPÉRER',
    name_recover_invalid: 'Le code doit avoir 6 caractères',
    name_recover_loading: 'Recherche...',
    name_recover_success: 'Identité récupérée !',
    name_recover_not_found: 'Code introuvable',
    name_recover_error: 'Erreur de connexion — réessaie',
    name_cta:           'Classements, Actualités & Communauté',

    // ── CreditsScene ────────────────────────────────────────────────────────
    credits_close: '✕  FERMER',
  },

  // ── CHINESE SIMPLIFIED ──────────────────────────────────────────────────────
  'zh-CN': {

    // ── TitleScene ──────────────────────────────────────────────────────────
    tips_label:   '提 示',
    options_btn:  '⚙  设置',
    tips: [
      '连接3个或更多方块以消除！',
      '能量条满时点击技能。',
      '4个以上的连击会产生棱晶碎片 ✦',
      '收集100个棱晶碎片即可获得一个战利品箱！',
      '每个战利品箱包含3张Pazurumon TCG卡牌。',
      '更大的连击会产生更稀有的碎片——好好练习！',
      '完成一关即可获得含3张TCG卡的战利品箱！',
      '传奇卡牌很稀有——出现在每个战利品箱的第3格。',
      '在地图的收藏按钮中查看你的卡牌收藏。',
      '每个区域有一个主导元素——善加利用！',
      '完成全部5个世界后解锁无限模式。',
    ],

    // ── MapScene ────────────────────────────────────────────────────────────
    region_label:       '区域 {n}',
    btn_collection:     '收藏',
    btn_scores:         '排行榜',
    btn_store:          '🔓 商店',
    btn_reset:          '重置',
    trainer_level:      '训练师 Lv.{n}',
    levels_count:       '30关卡',
    free:               '免费',
    region_unknown:     '未知区域',
    btn_infinite:       '∞ 无限',
    best:               '最佳: {n}',
    end_of_world:       '世界\n末日',
    region_locked_toast:'该区域仍已锁定。',
    levels_remaining:   '还需{n}关解锁！',
    btn_close:          '关闭',
    region_info:        '{label}  •  30关卡  •  免费',

    // ── StoreScene ──────────────────────────────────────────────────────────
    store_subtitle:       '完整冒险',
    store_desc:           '一次性解锁所有世界\n— 无订阅，无惊喜。',
    feature_volcano:      '火山',
    feature_storm:        '电气风暴',
    feature_ocean:        '深海',
    feature_earth:        '远古大地',
    feature_psychic:      '精神深渊',
    feature_infinite:     '无限模式',
    feature_badge:        '支持者徽章',
    feature_collection:   '便携收藏',
    feature_r1_sub:       '30关卡 — 所有人免费',
    feature_new_levels:   '解锁30个新关卡',
    feature_infinite_sub: '购买后立即解锁',
    feature_badge_sub:    '排行榜上高亮显示名字',
    feature_coll_sub:     '卡牌可导入Pazurumon TCG Online',
    badge_free:           '免费',
    payment_once:         '一次性\n付款',
    unlock_btn:           '立即解锁 — {price}',
    restore_purchase:     '恢复购买',
    btn_back:             '← 返回',
    processing:           '处理中...',
    payment_pending:      '在浏览器中完成付款 →',
    payment_open_tab:     '打开刚出现的标签页进行付款。',
    payment_error:        '付款错误。请重试。',
    restore_not_found:    '未找到购买记录。如已付款请联系支持。',
    tcg_header:           '🃏  你的进度不会消失',
    tcg_desc:             '你在本游戏中获得的卡牌可以导入\n到Pazurumon TCG Online。',
    collector_id:         '收藏家ID：{id}',
    store_footer:         '安全支付  •  无订阅  •  支持独立开发',
    game_unlocked_title:  '游戏已解锁！',
    game_unlocked_msg:    '欢迎进入完整冒险。\n所有世界和无限模式\n现已开放。',
    tcg_id_cards:         '🃏 TCG ID: {id}  •  已保存{n}张卡',
    start_adventure:      '开始冒险 →',

    // ── LootboxScene ────────────────────────────────────────────────────────
    lootbox_header:   '战利品箱已开启',
    tap_each_card:    '点击每张卡牌以揭示',
    duplicate:        '重复',
    next_level:       '下一关 →',
    map_btn:          '地图',
    or_back_map:      '或返回地图',
    cloud_sync:       '☁ 收藏已保存至云端  •  {n}张卡  •  ID: {id}',

    // ── LeaderboardScene ────────────────────────────────────────────────────
    loading:          '加载中...',
    lb_close:         '关闭',
    wave:             '第{n}波',
    your_rank:        '你的排名：#{rank}  •  {score}',
    complete_worlds:  '完成所有5个世界即可提交',
    play_to_board:    '游戏以登上排行榜',
    submit_btn:       '提交我的分数',
    submitting:       '提交中...',
    score_submitted:  '✓ 分数已提交！',
    server_error:     '服务器错误 — 请重试。',
    network_error:    '网络错误 — 请重试。',
    no_scores:        '暂无分数 — 成为第一个！',
    prompt_name:      '输入你的名字',
    prompt_public:    '将在排行榜上公开显示',
    prompt_cancel:    '取消',
    prompt_confirm:   '确认',

    // ── CollectionScene ─────────────────────────────────────────────────────
    collection_title: 'TCG收藏',
    cards_count:      '{n} / {total}张卡',
    fragments_bar:    '✦ 碎片: {n}/{max}  →  +1战利品箱',
    btn_map_back:     '← 地图',
    copies_one:       '你有1份',
    copies_many:      '你有{n}份',
    tap_close:        '点击关闭',

    // ── LevelScene ──────────────────────────────────────────────────────────
    objective:        '目标',
    level_label:      '关卡',
    level_status:     '第{n}关 — 目标: {type}',
    moves_label:      '{n}步',
    tap_start:        '点击开始',
    btn_map:          '← 地图',
    defeat:           '失败',
    taunts: [
      '太弱了……你会更强地回来吗？',
      '黑爪还能原谅弱者。',
      '火山没有怜悯。',
      '你有潜力。现在用出来。',
      '你以为这会很容易，对吗？',
    ],
    retry:            '再试一次',
    map_btn_plain:    '地图',
    infinite_title:   '∞ 无限模式',
    infinite_no_goals:'无目标。无步数限制。',
    infinite_time:    '你有3分钟尽可能得高分。',
    infinite_mult:    '每15步倍率提升。',
    no_record:        '暂无记录 — 成为第一个！',
    play_btn:         '开始',
    time_up:          '∞ 时间到',
    final_score:      '最终分数',
    new_record:       '✦ 新纪录！',
    max_wave:         '最高波次: {n}',
    play_again:       '再玩一次',
    victory:          '胜利',
    next_btn:         '下一关 →',
    wave_status:      '∞ 第{n}波  ×{mult}分数！',
    tap_reveal:       '点击揭示',
    added_bestiary:   '✦  已添加到图鉴  ✦',
    continue_btn:     '继续',
    goals_header:     '目标：',
    goal_collect:     '• 收集{n}个{color}',
    goal_score:       '• 达到{n}分',
    goal_fragments:   '• 获得{n}个棱晶碎片',
    no_goals:         '目标：—',
    score_prefix:     '分数：',
    combo_max:        '最大连击：x{n}',
    time_bonus:       '⏱ 时间奖励: +{n}  ({t}s 剩余)',
    level_up_msg:     '⬆️ 升级！第{n}级',
    skill_target:     '🎯 选择目标…然后做一个{color}连击以发射',
    skill_armed:      '⚡ 技能就绪：做一个{color}连击（最大组）以发射！（ESC取消）',
    skill_failed:     '💥 失败！需要{required}（最大组：{actual}）。-50%能量',
    shuffle_msg:      '↻ 无法移动 — 重新洗牌...',
    error_msg:        '⚠️ 错误 — 查看控制台',
    suspense: {
      fire:     '深处有什么在燃烧...',
      water:    '一股力量在水面下流动...',
      earth:    '大地因新的存在而颤抖...',
      electric: '空气中有不同的火花...',
      psychic:  '一个未知的心灵触碰了你...',
      default:  '阴影中有什么在移动...',
    },

    // ── NOXYS Cross-Promo ───────────────────────────────────────────────────
    noxys_coming_soon:  '即将推出',
    noxys_title:        'PAZZURUMON',
    noxys_subtitle:     'NOXYS — 故事模式',
    noxys_date:         '13.08.2026',
    noxys_tagline:      '记住这个日期。拯救普里斯玛拉。',
    noxys_cta:          '在Kickstarter上支持我们',
    noxys_dismiss:      '不再显示',

    // ── OptionsScene — Tile Style ─────────────────────────────────────────
    opt_tile_style:   '方块样式',
    opt_tile_classic: '经典',
    opt_tile_prism:   '棱镜',
    opt_tile_themed:  'PRISMARA',

    // ── ReplayScene (Pazurumon Camera) ───────────────────────────────────
    replay_btn:           '📹 创建剪辑',
    replay_turn:          '回合',
    replay_stickers:      '贴纸',
    replay_record:        '录制并分享',
    replay_recording:     '录制中...',
    replay_done:          '回放完成',
    replay_not_supported: '此设备不支持录制',
    replay_error:         '录制失败',
    replay_saved:         '剪辑已保存！',
    replay_screenshot:       '📸 截图',
    replay_screenshot_saved: '截图已保存！',

    // ── NameBuilderScene ──────────────────────────────────────────────────
    name_create_title: '创建你的身份',
    name_edit_title:   '编辑身份',
    name_subtitle:     '构建你的 Pazurumon 名字',
    name_slot_creature: '生物',
    name_slot_verb:     '动词',
    name_slot_noun:     '名词',
    name_slot_title:    '称号',
    name_slot_role:     '职业',
    name_slot_place:    '地点',
    name_slot_emoji:    '表情',
    name_slot_year:     '年份',
    name_randomize:     '🎲  随机',
    name_confirm:       '✓  创建身份',
    name_save:          '✓  保存身份',
    name_skip:          '暂时跳过',
    name_iam:           '我是',
    name_share:         '📤  分享',
    name_continue:      '继续 ▶',
    name_discord_label: 'Discord（可选）',
    name_discord_tap:   '点击添加 @用户名',
    name_discord_hint:  '可选 — 加入 Pazurumon 社区！',
    name_year_prompt:   '出生年份（2位数）',
    name_unlock_worlds: '完成 {n} 个世界',
    name_unlock_wave:   '无尽模式达到第 {n} 波',
    name_link_code:     '你的代码',
    name_link_hint:     '保存此代码以在任何设备上恢复你的身份',
    name_recover:       '我有代码',
    name_recover_title: '恢复身份',
    name_recover_hint:  '输入你的6位代码',
    name_recover_btn:   '恢复',
    name_recover_invalid: '代码必须为6个字符',
    name_recover_loading: '搜索中...',
    name_recover_success: '身份已恢复！',
    name_recover_not_found: '未找到代码',
    name_recover_error: '连接错误 — 请重试',
    name_cta:           '排行榜、新闻与社区',

    // ── CreditsScene ────────────────────────────────────────────────────────
    credits_close: '✕  关闭',
  },

  // ── JAPANESE ────────────────────────────────────────────────────────────────
  'ja-JP': {

    // ── TitleScene ──────────────────────────────────────────────────────────
    tips_label:   'ヒ ン ト',
    options_btn:  '⚙  設定',
    tips: [
      '3つ以上のタイルをつなげて消そう！',
      'エネルギーバーが満タンになったらスキルをタップ。',
      '4つ以上のコンボでプリスマラフラグメントが発生 ✦',
      'プリスマラフラグメントを100個集めてルートボックスを獲得！',
      '各ルートボックスには3枚のPazurumon TCGカードが入っています。',
      '大きなコンボほどレアなフラグメントが出る——練習あるのみ！',
      'ステージをクリアして3枚入りTCGルートボックスをゲット！',
      'レジェンダリーカードはレア——各ルートボックスのスロット3に出現。',
      'マップのコレクションボタンでカードを確認しよう。',
      '各地域には主要な属性がある——うまく活用しよう！',
      '全5ワールドをクリアすると無限モードが解放される。',
    ],

    // ── MapScene ────────────────────────────────────────────────────────────
    region_label:       '地域 {n}',
    btn_collection:     'コレクション',
    btn_scores:         'スコア',
    btn_store:          '🔓 ストア',
    btn_reset:          'リセット',
    trainer_level:      'トレーナー Lv.{n}',
    levels_count:       '30ステージ',
    free:               '無料',
    region_unknown:     '不明な地域',
    btn_infinite:       '∞ 無限',
    best:               'ベスト: {n}',
    end_of_world:       '世界の\n終わり',
    region_locked_toast:'この地域はまだロックされています。',
    levels_remaining:   'あと{n}ステージでアンロック！',
    btn_close:          '閉じる',
    region_info:        '{label}  •  30ステージ  •  無料',

    // ── StoreScene ──────────────────────────────────────────────────────────
    store_subtitle:       '完全冒険',
    store_desc:           '全ワールドを一度きりの価格で\nアンロック — サブスク不要、サプライズなし。',
    feature_volcano:      '火山',
    feature_storm:        '電気嵐',
    feature_ocean:        '深海',
    feature_earth:        '古代の大地',
    feature_psychic:      'サイキック深淵',
    feature_infinite:     '無限モード',
    feature_badge:        'サポーターバッジ',
    feature_collection:   'ポータブルコレクション',
    feature_r1_sub:       '30ステージ — 全員無料',
    feature_new_levels:   '30の新ステージをアンロック',
    feature_infinite_sub: '購入後すぐにアンロック',
    feature_badge_sub:    'リーダーボードでハイライト表示',
    feature_coll_sub:     'カードをPazurumon TCG Onlineにインポート可能',
    badge_free:           '無料',
    payment_once:         '一回\n払い',
    unlock_btn:           '今すぐアンロック — {price}',
    restore_purchase:     '購入を復元',
    btn_back:             '← 戻る',
    processing:           '処理中...',
    payment_pending:      'ブラウザで支払いを完了 →',
    payment_open_tab:     '表示されたタブを開いてお支払いください。',
    payment_error:        '支払いエラー。再試行してください。',
    restore_not_found:    '購入が見つかりません。支払い済みの場合はサポートへ。',
    tcg_header:           '🃏  進捗は消えません',
    tcg_desc:             'このゲームで獲得したカードは\nPazurumon TCG Onlineにインポートできます。',
    collector_id:         'コレクターID：{id}',
    store_footer:         '安全な支払い  •  サブスク不要  •  インディー開発を支援',
    game_unlocked_title:  'ゲームがアンロックされました！',
    game_unlocked_msg:    '完全な冒険へようこそ。\n全ワールドと無限モードが\n利用可能になりました。',
    tcg_id_cards:         '🃏 TCG ID: {id}  •  {n}枚のカードを保存',
    start_adventure:      '冒険を始める →',

    // ── LootboxScene ────────────────────────────────────────────────────────
    lootbox_header:   'ルートボックスを開封',
    tap_each_card:    '各カードをタップして公開',
    duplicate:        '重複',
    next_level:       '次のステージ →',
    map_btn:          'マップ',
    or_back_map:      'またはマップに戻る',
    cloud_sync:       '☁ コレクションをクラウドに保存  •  {n}枚  •  ID: {id}',

    // ── LeaderboardScene ────────────────────────────────────────────────────
    loading:          '読み込み中...',
    lb_close:         '閉じる',
    wave:             'ウェーブ{n}',
    your_rank:        'あなたのランク：#{rank}  •  {score}',
    complete_worlds:  '全5ワールドをクリアして投稿',
    play_to_board:    'プレイしてランキングに載ろう',
    submit_btn:       'スコアを投稿',
    submitting:       '投稿中...',
    score_submitted:  '✓ スコアを投稿しました！',
    server_error:     'サーバーエラー — 再試行してください。',
    network_error:    'ネットワークエラー — 再試行してください。',
    no_scores:        'まだスコアなし — 最初になろう！',
    prompt_name:      '名前を入力',
    prompt_public:    'リーダーボードで公開表示されます',
    prompt_cancel:    'キャンセル',
    prompt_confirm:   '確認',

    // ── CollectionScene ─────────────────────────────────────────────────────
    collection_title: 'TCGコレクション',
    cards_count:      '{n} / {total}枚',
    fragments_bar:    '✦ フラグメント: {n}/{max}  →  +1ルートボックス',
    btn_map_back:     '← マップ',
    copies_one:       '1枚持っています',
    copies_many:      '{n}枚持っています',
    tap_close:        'タップして閉じる',

    // ── LevelScene ──────────────────────────────────────────────────────────
    objective:        '目標',
    level_label:      'ステージ',
    level_status:     'ステージ{n} — 目標: {type}',
    moves_label:      '{n}手',
    tap_start:        'タップして開始',
    btn_map:          '← マップ',
    defeat:           '敗北',
    taunts: [
      '弱い……もっと強くなって戻ってくる？',
      '黒爪はまだ弱者を許している。',
      '火山に慈悲はない。',
      'お前には才能がある。今こそ使え。',
      '簡単だと思っていなかっただろう？',
    ],
    retry:            'もう一度',
    map_btn_plain:    'マップ',
    infinite_title:   '∞ 無限モード',
    infinite_no_goals:'目標なし。手数制限なし。',
    infinite_time:    '3分間で最高スコアを目指せ。',
    infinite_mult:    '15手ごとに倍率が上がる。',
    no_record:        'まだ記録なし — 最初になろう！',
    play_btn:         'プレイ',
    time_up:          '∞ 時間切れ',
    final_score:      '最終スコア',
    new_record:       '✦ 新記録！',
    max_wave:         '最大ウェーブ: {n}',
    play_again:       'もう一度プレイ',
    victory:          '勝利',
    next_btn:         '次へ →',
    wave_status:      '∞ ウェーブ{n}  ×{mult}スコア！',
    tap_reveal:       'タップして公開',
    added_bestiary:   '✦  図鑑に追加されました  ✦',
    continue_btn:     '続ける',
    goals_header:     '目標：',
    goal_collect:     '• {color}を{n}個集める',
    goal_score:       '• {n}ポイント達成',
    goal_fragments:   '• プリスマラフラグメントを{n}個獲得',
    no_goals:         '目標：—',
    score_prefix:     'スコア：',
    combo_max:        '最大コンボ：x{n}',
    time_bonus:       '⏱ タイムボーナス: +{n}  ({t}秒残り)',
    level_up_msg:     '⬆️ レベルアップ！レベル{n}',
    skill_target:     '🎯 ターゲットを選択…次に{color}コンボで発射',
    skill_armed:      '⚡ スキル準備完了：{color}コンボ（最大グループ）で発射！（ESCでキャンセル）',
    skill_failed:     '💥 失敗！{required}が必要（最大グループ：{actual}）。-50%エネルギー',
    shuffle_msg:      '↻ 手がない — シャッフル中...',
    error_msg:        '⚠️ エラー — コンソールを確認',
    suspense: {
      fire:     '深淵で何かが燃えている...',
      water:    '表面の下に何かが流れている...',
      earth:    '大地が新たな存在で震えている...',
      electric: '空気の中で異なる火花が弾けている...',
      psychic:  '未知の心があなたに触れている...',
      default:  '影の中で何かが動いている...',
    },

    // ── NOXYS Cross-Promo ───────────────────────────────────────────────────
    noxys_coming_soon:  '近日公開',
    noxys_title:        'PAZZURUMON',
    noxys_subtitle:     'NOXYS — ストーリーモード',
    noxys_date:         '13.08.2026',
    noxys_tagline:      'この日を忘れるな。プリスマラを救え。',
    noxys_cta:          'Kickstarterで応援する',
    noxys_dismiss:      '今後表示しない',

    // ── OptionsScene — Tile Style ─────────────────────────────────────────
    opt_tile_style:   'タイルスタイル',
    opt_tile_classic: 'クラシック',
    opt_tile_prism:   'プリズム',
    opt_tile_themed:  'PRISMARA',

    // ── ReplayScene (Pazurumon Camera) ───────────────────────────────────
    replay_btn:           '📹 クリップ作成',
    replay_turn:          'ターン',
    replay_stickers:      'ステッカー',
    replay_record:        '録画＆シェア',
    replay_recording:     '録画中...',
    replay_done:          'リプレイ完了',
    replay_not_supported: 'この端末では録画できません',
    replay_error:         '録画に失敗しました',
    replay_saved:         'クリップを保存しました！',
    replay_screenshot:       '📸 写真',
    replay_screenshot_saved: 'スクリーンショットを保存しました！',

    // ── NameBuilderScene ──────────────────────────────────────────────────
    name_create_title: 'アイデンティティを作成',
    name_edit_title:   'アイデンティティを編集',
    name_subtitle:     'Pazurumon の名前を作ろう',
    name_slot_creature: 'クリーチャー',
    name_slot_verb:     '動詞',
    name_slot_noun:     '名詞',
    name_slot_title:    '称号',
    name_slot_role:     '役職',
    name_slot_place:    '場所',
    name_slot_emoji:    '絵文字',
    name_slot_year:     '年',
    name_randomize:     '🎲  ランダム',
    name_confirm:       '✓  アイデンティティ作成',
    name_save:          '✓  保存',
    name_skip:          '今はスキップ',
    name_iam:           '私は',
    name_share:         '📤  シェア',
    name_continue:      '続ける ▶',
    name_discord_label: 'Discord（任意）',
    name_discord_tap:   'タップして @ユーザー名を追加',
    name_discord_hint:  '任意 — Pazurumon コミュニティに参加しよう！',
    name_year_prompt:   '生まれ年（2桁）',
    name_unlock_worlds: '{n} つのワールドをクリア',
    name_unlock_wave:   '無限モードでウェーブ {n} に到達',
    name_link_code:     'あなたのコード',
    name_link_hint:     'このコードを保存して、どのデバイスでもアイデンティティを復元できます',
    name_recover:       'コードを持っています',
    name_recover_title: 'アイデンティティを復元',
    name_recover_hint:  '6文字のコードを入力',
    name_recover_btn:   '復元',
    name_recover_invalid: 'コードは6文字です',
    name_recover_loading: '検索中...',
    name_recover_success: 'アイデンティティを復元しました！',
    name_recover_not_found: 'コードが見つかりません',
    name_recover_error: '接続エラー — もう一度お試しください',
    name_cta:           'リーダーボード、ニュース＆コミュニティ',

    // ── CreditsScene ────────────────────────────────────────────────────────
    credits_close: '✕  閉じる',
  },
};
